// Exports the "nonbreaking" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/nonbreaking')
//   ES2015:
//     import 'tinymce/plugins/nonbreaking'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./static/tinymce/plugins/nonbreaking/index.js
// module id = 60sc
// module chunks = 3